const ControlsLightValues = Object.freeze({
    placeholder: {
        default: '#929292',
        action: '#929292',
        active: '#929292',
        activeAction: '#929292',
    },
    caret: {
        default: '#5A00EE',
        action: '#5A00EE',
        active: '#5A00EE',
        activeAction: '#5A00EE',
    },
    border: {
        default: '#E0E0E0',
        action: '#E0E0E0',
        active: '#E0E0E0',
        activeAction: '#E0E0E0',
    },
    background: {
        default: '#FCFCFC',
        action: '#F7F7F7',
        active: '#EEEEEE',
        activeAction: '#F7F7F7',
    },
    text: {
        default: '#616161',
        action: '#4D4D4D',
        active: '#000000',
        activeAction: '#616161',
    },
    value: {
        default: '#616161',
        action: '#4D4D4D',
        active: '#000000',
        activeAction: '#616161',
    },
    startIcon: {
        default: '#616161',
        action: '#4D4D4D',
        active: '#000000',
        activeAction: '#616161',
    },
    endIcon: {
        default: '#616161',
        action: '#4D4D4D',
        active: '#000000',
        activeAction: '#616161',
    },
    sliderThumb: {
        default: '#FEFEFE',
        action: '#F1F1F1',
        active: '#FEFEFE',
        activeAction: '#F1F1F1',
    },
    sliderTrack: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const ControlsDarkValues = Object.freeze({
    placeholder: {
        default: '#737373',
        action: '#737373',
        active: '#737373',
        activeAction: '#737373',
    },
    caret: {
        default: '#BD99F8',
        action: '#BD99F8',
        active: '#BD99F8',
        activeAction: '#BD99F8',
    },
    border: {
        default: '#3B3B3B',
        action: '#3B3B3B',
        active: '#3B3B3B',
        activeAction: '#3B3B3B',
    },
    background: {
        default: '#121212',
        action: '#212121',
        active: '#2A2A2A',
        activeAction: '#212121',
    },
    text: {
        default: '#B3B3B3',
        action: '#CCCCCC',
        active: '#FFFFFF',
        activeAction: '#B3B3B3',
    },
    value: {
        default: '#B3B3B3',
        action: '#CCCCCC',
        active: '#FFFFFF',
        activeAction: '#B3B3B3',
    },
    startIcon: {
        default: '#B3B3B3',
        action: '#CCCCCC',
        active: '#FFFFFF',
        activeAction: '#B3B3B3',
    },
    endIcon: {
        default: '#B3B3B3',
        action: '#CCCCCC',
        active: '#FFFFFF',
        activeAction: '#B3B3B3',
    },
    sliderThumb: {
        default: '#FFFFFF',
        action: '#F1F1F1',
        active: '#FFFFFF',
        activeAction: '#F1F1F1',
    },
    sliderTrack: {
        default: '#FFFFFF',
        action: '#FFFFFF',
        active: '#FFFFFF',
        activeAction: '#FFFFFF',
    },
});

export { ControlsDarkValues, ControlsLightValues };
